<template lang="pug">
  v-card
    .d-flex.pl-6.pr-3.align-center.trainings-menu.card-header
      .d-flex.flex-column.align-center.mr-4(
        @click="setActiveLayout([LAYOUT_OPTIONS_QUERY.QUESTIONS, LAYOUT_OPTIONS_QUERY.GEVAARHERKENNING])"
        :class="{'active': isLayoutActive([LAYOUT_OPTIONS_QUERY.QUESTIONS, LAYOUT_OPTIONS_QUERY.GEVAARHERKENNING])}"
      )
        v-icon mdi-help-circle
        h3 Questions
      .d-flex.flex-column.align-center.mr-4(
        @click="setActiveLayout(LAYOUT_OPTIONS_QUERY.THEORIE)"
        :class="{'active': isLayoutActive(LAYOUT_OPTIONS_QUERY.THEORIE)}"
      )
        v-icon mdi-information-outline
        h3 Theorie
      .d-flex.flex-column.align-center.mr-4(
        @click="setActiveLayout(LAYOUT_OPTIONS_QUERY.VIDEO)"
        :class="{'active': isLayoutActive(LAYOUT_OPTIONS_QUERY.VIDEO)}"
      )
        v-icon mdi-video-outline
        h3 Video
      .d-flex.flex-column.align-center.mr-4(
        @click="setActiveLayout(LAYOUT_OPTIONS_QUERY.DRAG_AND_DROP)"
        :class="{'active': isLayoutActive(LAYOUT_OPTIONS_QUERY.DRAG_AND_DROP)}"
      )
        v-icon mdi-drag-variant
        h3 Drag and Drop
      .d-flex.flex-column.align-center.mr-4(
        @click="setActiveLayout(LAYOUT_OPTIONS_QUERY.NUMERIC)"
        :class="{'active': isLayoutActive(LAYOUT_OPTIONS_QUERY.NUMERIC)}"
      )
        v-icon mdi-numeric
        h3 Numeric
      .d-flex.flex-column.align-center.mr-4(
        @click="setActiveLayout(LAYOUT_OPTIONS_QUERY.PICTURE_SELECT)"
        :class="{'active': isLayoutActive(LAYOUT_OPTIONS_QUERY.PICTURE_SELECT)}"
      )
        v-icon mdi-image-check-outline
        h3 Picture
      v-btn(fab color="primary" @click="toggleQuestionCreate(true, $route.query.layout)" small).ml-auto
        v-icon(small) $vuetify.icons.plus
    v-divider
    .body.no-footer.inner-scroll
      filters(
        :layoutVal="layout"
        @filterChanged="loadList"
        ref="filters"
      )
      list(
        :loading="listLoading"
        @removeClicked="remove"
        @loadMoreClick="loadListMore"
        @itemEditClick="showItemEdit"
        @sortChanged="loadList"
        :headers="headers"
        :list="list"
        :exams="exams"
        :pagination="pagination"
        :layout="layout"
        preview-side="left"
        sortable
        draggable
        :isToggleList="true"
        ref="list"
      )
</template>
<script>
import TrainingSvc from "@/app/exercise/modules/trainings/core/training-service"
import ErrorMixin from "@/mixins/errors.mixin"
import FormErrors from "@/util/form-errors"
import {LAYOUT_OPTIONS_QUERY} from "@/app/exercise/components/question/core/question-const";
import Filters from "./TrainingsQuestionsFilters.vue"
import ExamSvc from "@/app/exercise/modules/exams/core/exam-service"
import EventBus from "@/util/event-bus"
import {LIST_EVENTS} from "@/const/list-events.enum";

export default {
  data: () => ({
    svc: null,
    examSvc: null,
    list: [],
    exams: [],
    listLoading: false,
    formErrors: null,
    pagination: null,
    LAYOUT_OPTIONS_QUERY,
    layout: null,
    headers: [
      { text: '', value: 'preview', class: 'app-table__h_small', sortable: false },
      { text: '', value: 'preview', class: 'app-table__h_small', sortable: false },
      // { text: 'ID', value: 'id', class: 'app-table__h_small', sortable: false },
      { text: 'Short name', align: 'left', value: 'name', class: 'nowrap' },
      { text: 'Chapter / Subchapter', align: 'left', value: 'chapter', class: 'nowrap', sortable: false },
      { text: 'Category', align: 'center', value: 'category', class: 'nowrap pl-4' },
      // { text: 'Layout', value: 'layout', class: 'nowrap' },
      { text: 'Actions', value: 'menu', align: 'center',  sortable: false },
    ],
  }),

  mixins: [ErrorMixin],

  created() {
    this.init()
  },

  async mounted() {
    this.loadData()
    EventBus.$on(LIST_EVENTS.UPDATE_LIST, () => {
      this.loadData()
    })
  },

  inject: [
    'toggleQuestionCreate',
    'showItemEdit'
  ],

  methods: {
    init() {
      this.svc = new TrainingSvc(this.$auth)
      this.examSvc = new ExamSvc(this.$auth)
      this.formErrors = new FormErrors()
      this.setDefaultLayout();
    },
    loadData() {
      Promise.all([
        this.loadList(),
        this.$refs.filters && this.$refs.filters.loadOptions(),
        this.loadExams()
      ])
    },
    async loadExams() {
      let { results } = await this.examSvc.list()
      this.exams = results
    },

    setDefaultLayout() {
      if (!this.$route.query.layout) this.$route.query.layout = [LAYOUT_OPTIONS_QUERY.QUESTIONS, LAYOUT_OPTIONS_QUERY.GEVAARHERKENNING];
    },

    setActiveLayout(activeLayout) {
      this.layout = activeLayout;
    },

    async loadPage(page) {
      this.listLoading = true
      let { results, pagination } = await this.svc.list({...this.$route.query, page})
      this.listLoading = false
      return { results, pagination };
    },

    async getQuestionPage(questionId) {
      this.listLoading = true
      const { page } = await this.svc.getPage({...this.$route.query}, questionId)
      this.listLoading = false
      return page
    },

    async loadList() {
      try {
        this.listLoading = true
        let { results, pagination } = await this.svc.list(this.$route.query)
        this.pagination = pagination;
        this.list = results
        this.listLoading = false
      } catch (error) {
        this.listLoading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    async loadListMore(page) {
      try {
        this.listLoading = true
        let { results } = await this.svc.list({
          ...this.$route.query,
          page
        })
        this.list.push(...results)
        this.listLoading = false
      } catch (error) {
        this.listLoading = false
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    async remove(item) {
      try {
        let itemIndex = this.list.findIndex(listItem => listItem.id === item.id)
        if(itemIndex < 0) throw new Error('This question was not found in the list.')
        await this.svc.remove(item);
        const { results, pagination } = await this.loadPage(item.page);
        this.pagination.count = pagination.count;
        this.replacePageAtList(item.page, results);
        this.$refs.list.setPage(item.page);
        this.$emit('onItemDelete');
      } catch (error) {
        this.processError(error, {redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE})
      }
    },

    isLayoutActive(layout) {
      return JSON.stringify(this.$route.query.layout) === JSON.stringify(layout);
    },

    replacePageAtList(page, part) {
      const startIndex = this.list.findIndex( item => item.page === page );
      if( startIndex >= 0 ) {
        this.list.splice(startIndex, this.list.length, ...part);
      }
    },

    async mergeUpdatedQuestionPage(page) {
      const { results, pagination } = await this.loadPage(page);
      this.pagination.count = pagination.count;
      this.replacePageAtList(page, results);
      this.$refs.list.setPage(page);
    },

  },

  components: {
    list: () => import('./TrainingsList.vue'),
    filters: Filters,
  }
}
</script>
<style lang="scss" scoped>
.trainings-menu {
  > div {
    cursor: pointer;
    .v-icon {
      color: inherit;
      font-size: 21px;
      margin-bottom: 4px;
    }
    h3 {
      font-size: 14px;
    }
    &.active {
      color: $primary-color;
    }
  }
}
</style>
